export function setPlaces(state, places) {
  state.places = places;
}

export function incrementPendingRequests(state) {
  state.pendingRequestsCount += 1;
}

export function decrementPendingRequests(state) {
  state.pendingRequestsCount -= 1;
}

export function removePlace(state, keyToRemove) {
  const clone = { ...state.places };
  delete clone[keyToRemove];
  state.places = clone;
}

export function insertPlace(state, place) {
  state.places = { ...state.places, [place.key]: place };
}

export function updatePlace(state, place) {
  state.places = {
    ...state.places,
    [place.key]: place,
  };
}

export function setPlaceVisits(state, visits) {
  state.placeVisits = visits;
}

export function initialized(state) {
  state.initialized = true;
}
